// Named HTTP status codes used across the app (avoids magic numbers).
export const HTTP_CONFLICT = 409;
export const HTTP_UNSUPPORTED_MEDIA = 415;
